import { memo, useState } from 'react';
import cn from 'classnames';
import { Button, Element, Icon, Title } from 'src/components';
import Card from 'src/components/card';
import Radio from 'src/components/form/radio';
import Message from 'src/components/message';
import SelectContent from './SelectContent';

export default memo(function ModalReport({ hide, contentId, reportFn }: any) {
    const [value, setValue] = useState(undefined);
    const [contents, setContent] = useState([]);
    const [other, setOther] = useState('');
    const [err, setErr] = useState('');
    const onChangeOption = (value: any) => {
        setValue(value);
        setErr('');
    };

    const handleSubmit = () => {
        let feedback: any = {
            type: value,
        };
        if (value === 'content') {
            if (!contents.length) {
                return setErr('Bạn chưa nhập nội dung');
            }
            feedback = {
                ...feedback,
                tags: contents,
            };
        } else if (value === 'other') {
            if (!other) {
                return setErr('Bạn chưa nhập nội dung');
            }
            feedback = {
                ...feedback,
                message: other,
            };
        }
        reportFn({
            object_id: contentId,
            feedback: JSON.stringify(feedback),
            object_type: 0,
        });
    };

    return (
        <Card>
            <Card.Header
                className={cn(
                    'relative',
                    'px-[25px] py-[15px]',
                    'text-center',
                    'border border-solid border-[#e9ecef]'
                )}
            >
                <Title className={'text-[2.4rem] leading-[30px] uppercase'}>
                    Báo tin xấu
                </Title>
                <Element className={'text-[1.6rem] leading-[22px]'}>
                    Bạn vui lòng cho biết bài viết gặp lỗi nội dung nào:
                </Element>
                <Element renderAs="a" onClick={hide}>
                    <Icon
                        className={cn(
                            'absolute top-[15px] right-[15px]',
                            'text-black text-[1.5rem]',
                            'opacity-50',
                            'hover:opacity-100'
                        )}
                        icon="close"
                    />
                </Element>
            </Card.Header>
            <Card.Content className="px-[25px] py-[20px]">
                <Radio value={value} onChange={onChangeOption}>
                    <Element
                        className={cn('block', 'px-[10px] py-[7px]', {
                            ['bg-[#f5f5f5]']: value === 'original_removed',
                        })}
                    >
                        <Radio.Item value="original_removed">
                            Tin gốc đã gỡ
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn('block', 'px-[10px] py-[7px]', {
                            ['bg-[#f5f5f5]']: value === 'original_updated',
                        })}
                    >
                        <Radio.Item value="original_updated">
                            Tin gốc đã cập nhật
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn('block', 'px-[10px] py-[7px]', {
                            ['bg-[#f5f5f5]']: value === 'content',
                        })}
                    >
                        <Radio.Item value="content">
                            Nội dung không phù hợp
                            {value === 'content' && (
                                <SelectContent
                                    setContent={setContent}
                                    contents={contents}
                                />
                            )}
                        </Radio.Item>
                    </Element>
                    <Element
                        className={cn('block', 'px-[10px] py-[7px]', {
                            ['bg-[#f5f5f5]']: value === 'other',
                        })}
                    >
                        <Radio.Item value="other">Ý kiến khác ...</Radio.Item>
                        {value === 'other' && (
                            <textarea
                                value={other}
                                onChange={(e) => {
                                    setOther(e.target.value);
                                    setErr('');
                                }}
                                className={cn(
                                    'w-full',
                                    'text-[1.6rem] leading-[1.3] text-[#495057]',
                                    'px-[0.75rem] py-[0.4rem] mt-[1rem]',
                                    'bg-white',
                                    'rounded-[0.25rem]',
                                    'border border-solid border-[#ced4da]'
                                )}
                                rows={3}
                            />
                        )}
                    </Element>
                </Radio>
                {err && <Message>Bạn chưa nhập nội dung!</Message>}
            </Card.Content>
            <Card.Footer
                className={cn(
                    'flex-nowrap',
                    'px-[25px] py-[20px]',
                    'h-auto',
                    'rounded-none',
                    'text-center',
                    'border border-solid border-[#e9ecef]'
                )}
            >
                <Button
                    className={cn(
                        'rounded-[3px]',
                        'w-[49%] h-auto',
                        'text-[#343a40] text-[1.8rem] leading-[1.5] font-bold uppercase',
                        'mx-[5px] px-[1rem] py-[0.5rem]',
                        'border border-solid border-[#e9ecef]',
                        'transition-colors duration-300'
                    )}
                    onClick={hide}
                    title="Đóng"
                >
                    Đóng
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                    className={cn(
                        'rounded-[3px]',
                        'w-[49%] h-auto',
                        'text-[1.8rem] leading-[1.5] font-bold uppercase',
                        'mx-[5px] px-[1rem] py-[0.5rem]',
                        'border border-solid border-[#e9ecef]'
                    )}
                    title="Gửi"
                >
                    Gửi báo lỗi
                </Button>
            </Card.Footer>
        </Card>
    );
});
